// Shared form primitives for the Admin panels. Tiny, dumb, controlled.
import React from "react";

export const LabeledInput = ({ label, value, onChange, testid, placeholder }) => (
  <div>
    <label className="block font-mono text-[10px] uppercase tracking-[0.25em] mb-1">{label}</label>
    <input
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      data-testid={testid}
      placeholder={placeholder}
      className="w-full border-2 border-asphalt bg-bone px-3 py-2 font-body"
    />
  </div>
);

export const LabeledTextarea = ({ label, value, onChange, rows = 3, testid }) => (
  <div>
    <label className="block font-mono text-[10px] uppercase tracking-[0.25em] mb-1">{label}</label>
    <textarea
      rows={rows}
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      data-testid={testid}
      className="w-full border-2 border-asphalt bg-bone px-3 py-2 font-body resize-none"
    />
  </div>
);

export const LabeledSelect = ({ label, value, onChange, options, testid }) => (
  <div>
    <label className="block font-mono text-[10px] uppercase tracking-[0.25em] mb-1">{label}</label>
    <select
      value={value || ""}
      onChange={(e) => onChange(e.target.value)}
      data-testid={testid}
      className="w-full border-2 border-asphalt bg-bone px-3 py-2 font-body"
    >
      {options.map((o) => (
        <option key={o.value} value={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  </div>
);
